"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _algolia = require("@insided/shared/services/algolia");

var _SearchBox = _interopRequireDefault(require("./SearchBox"));

var _algoliaService = require("@insided/deprecated-services/algoliaService");

var _components = require("../../components");

var _utils = require("../../utils");

var _FilterOverlay = require("./FilterOverlay");

var _AlgoliaEnhancedSearch = require("./AlgoliaEnhancedSearch");

var _SuggestedQuestionsRow = _interopRequireDefault(require("./SuggestedQuestionsRow"));

var _SearchHistoryService = require("../../services/SearchHistoryService");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function shouldDisplayFilterButton() {
  var _ref, _document$querySelect;

  if (typeof window === 'undefined') return false;
  return Boolean((_ref = (_document$querySelect = document.querySelector('[data-preact="destination/modules/Navigation/WidgetCategoryFilter/index.sync"]')) !== null && _document$querySelect !== void 0 ? _document$querySelect : document.querySelector('[data-preact="ideation-destination/filters/ProductAreaFilter"]')) !== null && _ref !== void 0 ? _ref : document.querySelector('[data-preact="ideation-destination/filters/IdeaStatusFilter"]'));
}

function getContentType(contentTypes) {
  if (contentTypes) return contentTypes;
  if (typeof window === 'undefined') return undefined;

  if (window.location.pathname.match(/^\/ideas/)) {
    return ['ideation'];
  }

  if (window.location.pathname.match(/^\/product-updates/)) {
    return ['productUpdate'];
  }

  if (window.location.pathname.match(/^\/events/)) {
    return ['event'];
  }

  return undefined;
}

var Search = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Search, _Component);

  var _super = _createSuper(Search);

  function Search(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Search);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "communityId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "defaultIndexList", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchById: false,
      searchByContentType: getContentType(_this.props.searchByContentType),
      finalInput: '',
      searchClient: undefined,
      listIndexes: [],
      isFiltersOverlay: false,
      isZendeskFederatedSearch: false,
      hiddenCategories: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateSearch", function (searchTerm, next) {
      _this.setState({
        searchById: searchTerm.q.match(/^[0-9]+$/) !== null,
        finalInput: searchTerm.q,
        searchByContentType: searchTerm.contentType ? [searchTerm.contentType] : getContentType(_this.props.searchByContentType)
      }, next);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "callback", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(data) {
        var _yield$Promise$all, _yield$Promise$all2, searchClient, _basicClient, isTokenRefresh, searchState, lastRequestKey, lastResponsePromise, originalSearch, indexes;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Promise.all([(0, _algolia.createAlgoliaClient)(data.client_id, data.token), (0, _algolia.createAlgoliaClient)(data.client_id, data.basicToken)]);

              case 2:
                _yield$Promise$all = _context3.sent;
                _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 2);
                searchClient = _yield$Promise$all2[0];
                _basicClient = _yield$Promise$all2[1];

                _this.setState({
                  isZendeskFederatedSearch: data.isZendeskFederatedSearchEnabled,
                  hiddenCategories: data.hiddenCategories
                }); // Track if this is a token refresh - first search after refresh should disable analytics


                isTokenRefresh = data.isTokenRefresh === true; // Create a mutable flag that persists across searches for this client instance

                searchState = {
                  disableAnalyticsForNextSearch: isTokenRefresh
                }; // Deduplicate identical consecutive searches caused by Preact re-renders

                lastRequestKey = null;
                lastResponsePromise = null;
                originalSearch = searchClient.search.bind(searchClient);

                searchClient.search = /*#__PURE__*/function () {
                  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(requests, _) {
                    var shouldDisableAnalytics, modifiedRequests, requestKey;
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!requests.some(function (request) {
                              var _request$params;

                              return (request === null || request === void 0 ? void 0 : (_request$params = request.params) === null || _request$params === void 0 ? void 0 : _request$params.query) === '';
                            })) {
                              _context2.next = 2;
                              break;
                            }

                            return _context2.abrupt("return", {
                              results: []
                            });

                          case 2:
                            // Check if we should disable analytics for this search
                            shouldDisableAnalytics = searchState.disableAnalyticsForNextSearch; // Reset the flag after checking - subsequent user searches should track analytics

                            if (searchState.disableAnalyticsForNextSearch) {
                              searchState.disableAnalyticsForNextSearch = false;
                            }

                            modifiedRequests = requests.map(function (request) {
                              var _request$params$query, _request$params2;

                              var query = (_request$params$query = request === null || request === void 0 ? void 0 : (_request$params2 = request.params) === null || _request$params2 === void 0 ? void 0 : _request$params2.query) !== null && _request$params$query !== void 0 ? _request$params$query : '';
                              var isEmptyQuery = !query || query.trim() === ''; // Disable analytics for empty queries OR token refresh searches

                              if ((isEmptyQuery || shouldDisableAnalytics) && request !== null && request !== void 0 && request.params) {
                                return _objectSpread(_objectSpread({}, request), {}, {
                                  params: _objectSpread(_objectSpread({}, request.params), {}, {
                                    analytics: false,
                                    clickAnalytics: false
                                  })
                                });
                              }

                              return request;
                            }); // Create a cache key from the request parameters (excluding analytics flags)

                            requestKey = JSON.stringify(modifiedRequests.map(function (r) {
                              var _r$params, _r$params2, _r$params3, _r$params4;

                              return {
                                indexName: r.indexName,
                                query: (_r$params = r.params) === null || _r$params === void 0 ? void 0 : _r$params.query,
                                page: (_r$params2 = r.params) === null || _r$params2 === void 0 ? void 0 : _r$params2.page,
                                filters: (_r$params3 = r.params) === null || _r$params3 === void 0 ? void 0 : _r$params3.filters,
                                facetFilters: (_r$params4 = r.params) === null || _r$params4 === void 0 ? void 0 : _r$params4.facetFilters
                              };
                            })); // If this is the same request as the last one, return the cached promise
                            // This deduplicates identical searches caused by Preact re-renders

                            if (!(requestKey === lastRequestKey && lastResponsePromise)) {
                              _context2.next = 8;
                              break;
                            }

                            return _context2.abrupt("return", lastResponsePromise);

                          case 8:
                            // Store the request key before making the call
                            lastRequestKey = requestKey; // Create and cache the response promise

                            lastResponsePromise = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                              var originalSearchResponse;
                              return _regenerator.default.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.prev = 0;
                                      _context.next = 3;
                                      return originalSearch(modifiedRequests);

                                    case 3:
                                      originalSearchResponse = _context.sent;
                                      return _context.abrupt("return", originalSearchResponse);

                                    case 7:
                                      _context.prev = 7;
                                      _context.t0 = _context["catch"](0);
                                      // Clear cache on error so next identical request retries
                                      lastRequestKey = null;
                                      lastResponsePromise = null;
                                      throw _context.t0;

                                    case 12:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, null, [[0, 7]]);
                            }))();
                            return _context2.abrupt("return", lastResponsePromise);

                          case 11:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2, _x3) {
                    return _ref3.apply(this, arguments);
                  };
                }(); // Use pre-computed availableIndexes from backend (unified index is always enabled)


                indexes = data.availableIndexes && data.availableIndexes.length > 0 ? data.availableIndexes : _this.defaultIndexList;

                _this.setState({
                  listIndexes: indexes,
                  searchClient: searchClient
                }); // Kick off the recents cleanup now that credentials are ready. By the time
                // the user focuses the search box (usually 1–5s later) the deleted-article
                // entries have already been filtered out of localStorage, so the dropdown
                // renders clean with no flicker. The dropdown-mount call inside
                // HitContainerRecents remains as a fallback for the race where focus
                // happens before this resolves; the in-flight promise is memoized so the
                // second call is a no-op.


                if (!_SearchHistoryService.searchHistoryService.isEmpty()) {
                  _SearchHistoryService.searchHistoryService.validateAndCleanCommunityResults();
                }

                (0, _algoliaService.insights)('init', {
                  appId: data.client_id,
                  apiKey: data.token
                });

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _this.communityId = (0, _utils.getCommunityId)(); // Unified index is always enabled

    _this.defaultIndexList = ["".concat(_this.communityId, "-unified")];
    return _this;
  }

  (0, _createClass2.default)(Search, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _algoliaService.getSearchToken)(this.callback);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "revertFilters",
    value: function revertFilters(e) {
      e.stopPropagation();
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('revertFilters'));
      this.filtersOverlayHandler(e, false);
    }
  }, {
    key: "filtersOverlayHandler",
    value: function filtersOverlayHandler(e, value) {
      var _this2 = this;

      e.stopPropagation();
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('filter', {
        detail: {
          display: value
        }
      }));

      if (value) {
        this.setState({
          isFiltersOverlay: value
        });
      } else {
        /*
          Items that should be in the filters are added via Portal component
          having setTimeout here is making state change async and give time to filter component to unmount
        */
        window.setTimeout(function () {
          _this2.setState(function (state) {
            return {
              isFiltersOverlay: !state.isFiltersOverlay
            };
          });
        }, 0);
      }

      var bodyEl = document.querySelector('body');

      if (bodyEl) {
        if (bodyEl.style.overflow === 'hidden') {
          bodyEl.style.overflow = 'visible';
        } else {
          bodyEl.style.overflow = 'hidden';
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props$submitIconType,
          _props$submitIconType2,
          _this3 = this,
          _props$liveSearchSugg;

      var props = this.props,
          state = this.state;
      var isAlgoliaReady = state.searchClient && state.listIndexes.length > 0;
      return (0, _preact.h)("div", {
        className: "search-widget-with-suggestions"
      }, (0, _preact.h)("div", {
        className: "search-and-filter-wrapper"
      }, (0, _preact.h)("div", {
        style: {
          position: 'relative',
          width: '100%'
        }
      }, (0, _preact.h)("div", null, (0, _preact.h)(_SearchBox.default, {
        submitIconType: (_props$submitIconType = props.submitIconType) !== null && _props$submitIconType !== void 0 ? _props$submitIconType : '',
        enableFocusToSearch: props.enableFocusToSearch,
        forethoughtAgent: props.forethoughtAgent,
        doSearch: function doSearch() {}
      })), isAlgoliaReady && (0, _preact.h)("div", {
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        }
      }, (0, _preact.h)(_AlgoliaEnhancedSearch.AlgoliaEnhancedSearch, (0, _extends2.default)({}, props, {
        searchClient: state.searchClient,
        updateSearch: this.updateSearch,
        searchById: state.searchById,
        searchInContentCategories: props.searchInContentCategories,
        searchInProductAreas: props.searchInProductAreas,
        searchByContentType: state.searchByContentType,
        finalInput: state.finalInput,
        categoryId: props.category,
        communityId: this.communityId,
        submitIconType: (_props$submitIconType2 = props.submitIconType) !== null && _props$submitIconType2 !== void 0 ? _props$submitIconType2 : '',
        listIndexes: state.listIndexes,
        isZendeskFederatedSearch: state.isZendeskFederatedSearch,
        hiddenCategories: state.hiddenCategories,
        aiSearchSummary: props.aiSearchSummary,
        askAISearchSummary: props.askAISearchSummary,
        isGuest: props.isGuest,
        aiSmartSearchEnableForAllRoles: props.aiSmartSearchEnableForAllRoles
      })))), shouldDisplayFilterButton() && (0, _preact.h)(_components.InstantSearchFilterButton, {
        onClick: function onClick(event) {
          return _this3.filtersOverlayHandler(event, true);
        }
      }), state.isFiltersOverlay && (0, _preact.h)(_FilterOverlay.FilterOverlay, {
        onClose: function onClose(e) {
          return _this3.revertFilters(e);
        }
      })), (0, _preact.h)(_SuggestedQuestionsRow.default, {
        questions: (_props$liveSearchSugg = props.liveSearchSuggestedQuestions) !== null && _props$liveSearchSugg !== void 0 ? _props$liveSearchSugg : [],
        centered: props.centered
      }));
    }
  }]);
  return Search;
}(_preact.Component);

exports.default = Search;